import { render, staticRenderFns } from "./konfigurasiakun.vue?vue&type=template&id=78117559&scoped=true&"
import script from "./konfigurasiakun.vue?vue&type=script&lang=js&"
export * from "./konfigurasiakun.vue?vue&type=script&lang=js&"
import style0 from "./konfigurasiakun.vue?vue&type=style&index=0&id=78117559&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78117559",
  null
  
)

export default component.exports